import TextPath from './../components/TextPath';

const drawText = (colors, text, pathId, offset, fontSize = 20, fontColor = colors.gray, yOffset = 0 ) => {
    return TextPath.create(pathId)
        .textColor(fontColor)
        .text(text)
        .offset(offset)
        .yOffset(yOffset)
        .fontSize(fontSize)
        .element();
};

export default drawText;
